import { useTheme } from '@mui/material';
const useCardStyles = () => {
    const theme = useTheme();
    return {
        cardStyles: {
            padding: 1.5,
            maxWidth: 361,
            width: '100%',
            height: 244,
            overflow: 'unset'
        },
        cardMediaStyles: {
            borderRadius: 1
        },
        cardContentStyles: {
            p: '12px 0 !important'
        },
        cardContentInnerStyles: {
            display: 'flex',
            flexDirection: 'row'
        },
        leftSectionStyles: {
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            gap: 0.25,
            flex: 1
        },
        titleStyles: {
            color: theme.palette.text.primary
        },
        subHeaderStyles: {
            color: theme.palette.text.secondary
        },
        rightSectionStyles: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 0.5
        },
        badgeStyles: {
            width: 20,
            height: 20,
            borderRadius: '50%',
            display: 'inline-flex',
            justifyContent: 'center',
            alignItems: 'center',
            backgroundColor: theme.palette.error.main
        },
        badgeCountStyles: {
            color: theme.palette.common.white
        }
    };
};
export default useCardStyles;
